export enum CategoryType {
    Opaque = "Opaque",
    Window = "Window",
    Corner = "Corner",
    CustomPanel = "Custom Panel",
    CustomCorner = "Custom Corner",
    CustomZShapedPanel = "Custom Z-Shaped",
}
